// Logout global. Chama signOut do Firebase, redireciona pra /login.html.
//
// Exposto como window.logoutConfirm pra ser usado por onclick inline em
// home.html (classic-defer + legado) e index.html (módulo Vite). Usa
// confirm() nativo pra evitar depender de modais-custom que podem não
// estar carregados em todas as páginas.

import { signOut } from '../../core/auth.js';
// Side-effect: instala o guard que faz o botão "voltar" do celular fechar o
// modal aberto em vez de sair da página. logout.js é importado por todas as
// páginas internas do app, então é um ponto de instalação global conveniente.
import '../../core/modalBackGuard.js';

export async function logoutConfirm() {
  if (!confirm('Sair da sua conta?')) return;
  try { await signOut(); }
  catch (e) { console.error('Erro no logout:', e); }
  // Limpa cache local — dados sensíveis (saldos, trips) não devem persistir
  // após logout em navegadores compartilhados.
  try { localStorage.clear(); } catch (e) {}
  // Força reload pra login garantir que nenhum módulo em memória ainda
  // referencia o usuário anterior.
  location.replace('/login.html');
}

globalThis.logoutConfirm = logoutConfirm;
